<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Select Location</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label for="searchInput">Search Locations</label>
      <input type="text" class="form-control" id="searchInput"
             name="searchInput"
             ngbAutofocus
             [(ngModel)]="searchInput"
             (ngModelChange)="handleSearchInputChange()">
    </div>

    <!-- Add a fixed-height div to prevent the modal from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto">

      <table class="table table-bordered table-hover"
             *ngIf="selectedLocation === null">
        <tbody *ngIf="loadingLocations">
          <tr>
            <td colspan="99">
              Loading...
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!loadingLocations">
          <tr *ngIf="filteredLocations().length === 0">
            <td colspan="99" class="text-muted">
              No locations
              <span *ngIf="searchInput !== ''">matching search</span>
            </td>
          </tr>
          <tr style="cursor:pointer"
              *ngFor="let loc of filteredLocations()"
              (click)="selectLocation(loc)">
            <td>
              {{ loc.name }}
            </td>
          </tr>
        </tbody>
      </table>

    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Submit
    </button>
  </div>

</ng-container>
